import gql from "graphql-tag";

export const GET_MIRO = gql`
  query ($input: getWorkspacesWidgetsInput) {
    getMiro(input: $input) {
      url
    }
  }
`;
